import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import assets from "../assets/imgs";
import config from "../config/config";
import ToggleButton from "../components/ToggleButton";
import AgreementPage from "../components/AgreementPage";
const API_URL = config.API_URL;


function PasswordFinder() {
  // const [orgNum, setOrgNum] = useState("");
  const [email, setEmail] = useState("");
  const [account, setAccount] = useState("");
  const [code, setCode] = useState("");
  const [passChange, setPassChange] = useState("");
  const [passChangeConfirm, setPassChangeConfirm ] = useState("");
  const [error, setError] = useState("");
  const [phone, setPhone] = useState("");
  const [emailOrPhone, setEmailOrPhone] = useState(true);
  const navigate = useNavigate();
  const [showCode, setShowCode] = useState(false);
  const [showPassChange, setShowPassChange] = useState(false);

  const [modal, setModal] = useState(false);

  const handleSubmit = async (e) =>{
    e.preventDefault();
    const isAccountTyped = (account.length > 0);
    if(!isAccountTyped){
      alert("계정을 입력해 주세요.");
      return;
    }
    // if(orgNum.length <=0){
    //   alert("기관코드를 입력해 주세요");
    //   return
    // }
    if(emailOrPhone){
      if(email.length <=0){
        const isEmailValid = email === "admin" || /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
        if (!isEmailValid) {
          alert("유효한 이메일을 입력하세요.");
          return;
        }
      }
    }else{
      const isPhoneValid = /^010-\d{4}-\d{4}$/.test(phone);
      if(!isPhoneValid){
        alert("유효한 전화번호를 입력해주세요");
        return;
      }
    }
    
    if(!showCode && !showPassChange){
      try{
        const response = await fetch(`${API_URL}/api/auth/passwordUserCheck`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            // orgNum: orgNum,
            account: account,
            ...(emailOrPhone ? { email: email } : { phone: phone })
          }),
        });
        if (response.ok) {
          const data = await response.json();
          if(data.result){
            setShowCode(true);          
            alert(data.message);
          }else{
            alert(data.message);
          }
        } else {
          const errorData = await response.json();
          setError(errorData.message);
        }
      }catch(error){
        console.error("Error:", error);
        setError("오류가 발생했습니다. 콘솔을 확인하세요.");
      }
    }else if(showCode && !showPassChange){
      if(code.length <=0){
        alert("확인코드를 입력해수제요.");
        return
      }
      try{
        const response = await fetch(`${API_URL}/api/auth/passwordCodeCheck`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            // orgNum: orgNum,
            account: account,
            ...(emailOrPhone ? { email: email } : { phone: phone }),
            code: code,
          }),
        });
        if (response.ok) {
          const data = await response.json();
          if(data.result){
            setShowPassChange(true);          
            alert('인증되었습니다.');
          }else{
            alert(data.message);
          }
        } else {
          const errorData = await response.json();
          setError(errorData.message);
        }
      }catch(error){
        console.error("Error:", error);
        setError("오류가 발생했습니다. 콘솔을 확인하세요.");
      }
    }else if(showCode && showPassChange){
      const isPasswordSame = ((passChange.length >= 6) && (passChange === passChangeConfirm));
      if(!isPasswordSame){
        if(passChange.length < 6){
          alert('6자리 이상의 비밀번호를 설정해 주세요.');
          return;
        }
        alert("비밀번호가 다릅니다.");
        return;
      }
      try{
        const response = await fetch(`${API_URL}/api/auth/passwordChange`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            // orgNum: orgNum,
            account: account,
            ...(emailOrPhone ? { email: email } : { phone: phone }),
            password: passChange,
          }),
        });
        if (response.ok) {
          const data = await response.json();
          if(data.result){
            alert('비밀번호 변경이 완료되었습니다.');
            navigate("/");
          }else{
            alert(data.message);
          }
        } else {
          const errorData = await response.json();
          setError(errorData.message);
        }
      }catch(error){
        console.error("Error:", error);
        setError("오류가 발생했습니다. 콘솔을 확인하세요.");
      }

    }else{
      alert('관리자에게 문의해주세요');
    }   
    
  }
  const formatPhoneNumber = (value) =>{
    const numbersOnly = value.replace(/\D/g, "");

    if (numbersOnly.length < 4) {
      return numbersOnly;
    } else if (numbersOnly.length < 8) {
      return `${numbersOnly.slice(0, 3)}-${numbersOnly.slice(3)}`;
    } else {
      return `${numbersOnly.slice(0, 3)}-${numbersOnly.slice(3, 7)}-${numbersOnly.slice(7, 11)}`;
    }
  }

  const handlePhoneChange = (e) => {
    const formattedPhone = formatPhoneNumber(e.target.value);
    setPhone(formattedPhone);
  };

  return (
    <div style={styles.divBody}>
      <div style={styles.loginRight}>
        <form style={styles.divLoginColumn} onSubmit={handleSubmit}>
          <div style={styles.divLoginColumnBody}>
            {/* 오류 메시지 표시 */}
            {error && (
              <p style={{ color: "red", fontSize: "14px", marginBottom: "16px" }}>
                {error}
              </p>
            )}
            {/* <div style={styles.divLoginInput}>
              <h3 style={styles.loginLabel}>기관코드</h3>
              <input
                style={{...styles.inputLoginInput, 
                  backgroundColor: !showCode ? "#ffffff" : "#dddde2"
                }}
                onChange={(e) => setOrgNum(e.target.value)}
                placeholder="기관코드를 입력해주세요."
                disabled = {showCode}
              />
            </div> */}
            <div style={styles.divLoginInput}>
              <h3 style={styles.loginLabel}>아이디</h3>
              <input
                style={{...styles.inputLoginInput, 
                  backgroundColor: !showCode ? "#ffffff" : "#dddde2"
                }}
                onChange={(e) => setAccount(e.target.value)}
                placeholder="아이디를 입력해주세요."
                disabled = {showCode}
              />
            </div>
            <ToggleButton leftLabel="이메일" rightLabel="연락처" value={emailOrPhone} onToggle={(e) => {if(e === true){setEmailOrPhone(e);}else{alert('준비중인 기능입니다.');}}} disabled={showCode}/>
            {emailOrPhone 
            ? (
              <div style={styles.divLoginInput}>
                <h3 style={styles.loginLabel}>이메일</h3>
                <input
                  style={{...styles.inputLoginInput, 
                    backgroundColor: !showCode ? "#ffffff" : "#dddde2"
                  }}
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  placeholder="이메일을 입력해주세요."
                  disabled = {showCode}
                />
              </div>
            )
            :(
              <div style={styles.divLoginInput}>
                <h3 style={styles.loginLabel}>전화번호</h3>
                <input
                  style={{...styles.inputLoginInput, 
                    backgroundColor: !showCode ? "#ffffff" : "#dddde2"
                  }}
                  onChange={handlePhoneChange}
                  value={phone}
                  maxLength={13}
                  placeholder="연락처를 입력해주세요.(숫자만)"
                  disabled = {showCode}
                />
              </div>
            )}
            <button type="submit" style={{...styles.btnLogin,
              cursor : !showCode ? "pointer" : "default",
              backgroundColor: !showCode ? "#6470dd" : "#686769",
              color : !showCode ? "white" :" #7A7A7B"
            }} disabled={showCode}>
              확인 코드 받기
            </button>
            {showCode && 
            (
              <>
                <div style={styles.divLoginInput}>
                  <h3 style={styles.loginLabel}>확인코드</h3>
                  <input
                    style={{...styles.inputLoginInput, 
                      backgroundColor: !showPassChange ? "#ffffff" : "#dddde2"
                    }}
                    value={code}
                    onChange={(e) => setCode(e.target.value)}
                    placeholder="확인코드(6자리)를 입력해주세요."
                    disabled= {showPassChange}
                  />
                </div>
                <button type="submit" style={{...styles.btnLogin,
                  cursor : !showPassChange ? "pointer" : "default",
                  backgroundColor: !showPassChange ? "#6470dd" : "#686769",
                  color : !showPassChange ? "white" :" #7A7A7B"
                }} disabled={showPassChange}>
                  코드 확인 하기
                </button>
              </>
            )}
            
            {showPassChange && 
            (
              <>
                <div style={styles.divLoginInput}>
                  <h3 style={styles.loginLabel}>변경 비밀번호</h3>
                  <input
                    style={styles.inputLoginInput}
                    type="password"
                    value={passChange}
                    onChange={(e) => setPassChange(e.target.value)}
                    placeholder="변경할 비밀번호를 입력해 주세요."
                  />
                </div>
                <div style={styles.divLoginInput}>
                  <h3 style={styles.loginLabel}>변경 비밀번호 확인</h3>
                  <input
                    style={styles.inputLoginInput}
                    type="password"
                    value={passChangeConfirm}
                    onChange={(e) => setPassChangeConfirm(e.target.value)}
                    placeholder="변경할 비밀번호를 다시 한번 더 입력해 주세요."
                  />
                </div>
                <button type="submit" style={{...styles.btnLogin,
                }}>
                  비밀번호 변경하기
                </button>
              </>
            )}
          </div>
        </form>
      </div>

      {/* {isAgreementOpen && <AgreementPage onClose={closeAgreement} onAgree={closeAgreementWithAgree}/>} */}
    </div>
  );
}

const input ={
  boxSizing : "border-box"
}

const styles = {
  divBody: {
    display: "flex", width: "1440px",
    height: "100vh", justifyContent: "center"
  },
  imgs: {
    width: "50%",
    height: "auto",
  },
  loginRight: {
    backgroundColor: "white",
    width: "50%",
    height: "100%",
    borderRadius: "0px 24px 24px 0px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    boxShadow: "0px 4px 12.6px 0px rgba(90, 87, 93, 0.14)",
  },
  divLoginColumn: {
    display: "flex",
    flexDirection: "column",
    gap: "44px",
    width: "100%",
    margin: "40px 70px 80px 70px"
  },
  divLoginColumnBody: {
    display: "flex",
    flexDirection: "column",
    gap: "12px",
    alignItems: "center",
    justifyContent: "flex-start",
  },
  divLoginInput: {
    ...input,
    boxSizing: "border-box",
    display: "flex",
    flexDirection: "column",
    gap: "6px",
    alignItems: "flex-start",
    justifyContent: "center",
    alignSelf: "stretch",
    overflow: "hidden",
  },
  divDoubleInput: {
    ...input,
    boxSizing: "border-box",
    display: "flex",
    flex:"1",
    flexDirection: "column",
    gap: "6px",
    alignItems: "flex-start",
    justifyContent: "center",
    alignSelf: "stretch",
    overflow: "hidden",
  },
  rowAccount:{
    display: "flex",
    gap: "16px",
    width: "100%"
  },
  btnAccountCheck:{
    width: "104px",
    backgroundColor: "var(--grayscale_60)",
    borderRadius: "8px",
    color: "white",
    flexShrink: 0,
  },
  rowDouble:{
    display:"flex",
    width: "100%",
    gap:"16px",
    justifyContent: "space-between",
  },
  loginLabel: {
    color: "#232323",
    fontFamily: "Pretendard-SemiBold, sans-serif",
    fontSize: "12px",
    lineHeight: "20px",
    fontWeight: 600,
  },
  inputLoginInput: {
    ...input,
    background: "#ffffff",
    borderRadius: "8px",
    borderStyle: "solid",
    borderColor: "#dddde2",
    borderWidth: "1px",
    padding: "12px 16px 12px 12px",
    width: "100%",
  },
  btnLogin: {
    background: "#6470dd",
    border: "0px",
    borderRadius: "8px",
    padding: "12px",
    display: "flex",
    gap: "10px",
    alignItems: "center",
    justifyContent: "center",
    alignSelf: "stretch",
    color: "white",
    fontFamily: "Pretendard-SemiBold, sans-serif",
    fontSize: "16px",
    lineHeight: "24px",
    fontWeight: 600,
    cursor: "pointer",
  },
  divLoginColumnFoot: {
    display: "flex",
    gap: "24px",
  },
  divLoginColumnFootP: {
    color: "#515052",
    fontFamily: "Pretendard",
    fontSize: "14px",
    fontStyle: "normal",
    fontWeight: 500,
    lineHeight: "21px",
  },
  rowAgree:{
    display:"flex",
    width:"100%", justifyContent: "space-between"
  },
  rowCheckBox:{
    display:"flex", gap:"12px", cursor:"pointer"
  },
  checkBox:{
    margin: "0", width:"20px", 
  },


  container: { display: "flex", justifyContent: "center", alignItems: "center", height: "100vh" },
  form: { backgroundColor: "#fff", padding: "2rem", borderRadius: "10px", boxShadow: "0 4px 8px rgba(0,0,0,0.1)" },
  inputGroup: { marginBottom: "1rem" },
  button: { padding: "0.5rem", backgroundColor: "#4CAF50", color: "white", border: "none", cursor: "pointer" },
};

export default PasswordFinder;